"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ariaRevertOthers = exports.ariaHideOthers = void 0;
/**
 * Set Aria-Hidden on parent node siblings up to the body tag.
 * The previous state is saved in the DOM so that it can be reversed.
 * @param node
 */
var ariaHideOthers = function (node) {
    if (!node.parentNode) {
        return;
    }
    if (node.tagName === 'BODY') {
        return;
    }
    var parent = node.parentNode;
    for (var i = 0; i < parent.children.length; i += 1) {
        var element = parent.children[i];
        if (element !== node) {
            // Save aria hidden state and set to hidden
            var ariaHiddenState = element.getAttribute('aria-hidden');
            if (ariaHiddenState !== null) {
                element.setAttribute('data-hidden', ariaHiddenState);
            }
            element.setAttribute('aria-hidden', 'true');
            // Save tabindex state and set to -1
            var tabindex = element.getAttribute('tabindex');
            if (tabindex !== null) {
                element.setAttribute('data-tabindex', tabindex);
            }
            element.setAttribute('tabindex', '-1');
        }
    }
    (0, exports.ariaHideOthers)(parent);
};
exports.ariaHideOthers = ariaHideOthers;
/**
 * Reset Aria-Hidden on parent node siblings up to the body tag.
 * This will revert changes made by
 * @param node
 */
var ariaRevertOthers = function (node) {
    if (!node.parentNode) {
        return;
    }
    if (node.tagName === 'BODY') {
        return;
    }
    var parent = node.parentNode;
    for (var i = 0; i < parent.children.length; i += 1) {
        var element = parent.children[i];
        if (element !== node) {
            // Restore aria-hidden state
            var ariaHiddenPrevious = element.getAttribute('data-hidden');
            if (ariaHiddenPrevious === null) {
                element.removeAttribute('aria-hidden');
            }
            else {
                element.setAttribute('aria-hidden', ariaHiddenPrevious);
            }
            element.removeAttribute('data-hidden');
            // Restore tabindex state
            var tabIndexPrevious = element.getAttribute('data-tabindex');
            if (tabIndexPrevious === null) {
                element.removeAttribute('tabindex');
            }
            else {
                element.setAttribute('tabindex', tabIndexPrevious);
            }
            element.removeAttribute('data-tabindex');
        }
    }
    (0, exports.ariaRevertOthers)(parent);
};
exports.ariaRevertOthers = ariaRevertOthers;
